import { render, staticRenderFns } from "./DistributionBoard.vue?vue&type=template&id=f8a3c88c&scoped=true"
import script from "./DistributionBoard.vue?vue&type=script&lang=js"
export * from "./DistributionBoard.vue?vue&type=script&lang=js"
import style0 from "./DistributionBoard.vue?vue&type=style&index=0&id=f8a3c88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a3c88c",
  null
  
)

export default component.exports